import { render, staticRenderFns } from "./EducationalCategoryUpdate.vue?vue&type=template&id=274fe14b&"
import script from "./EducationalCategoryUpdate.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports